import { createContext, useState } from "react";

export const SAMContext = createContext();

const intialSAMFilters = {
    staffType: "",
    status: "",
    accessModule: "",
    staffBelongsTo: "",
    updatedAt: "",
    createdAt: "",
    startDate:"",
    endDate:""
  }

export const SAMProvider = ({ children }) => {
  const [samSearchTerm, setSamSearchTerm] = useState("");
  const [samFilters, setSamFilters] = useState(intialSAMFilters);
  const [ContextCurrentPage, contextSetCurrentPage] = useState(1);
  const [ContextTotalPages, contextSetTotalPages] = useState(0);
  const [Contextlimit] = useState(5);
  const [ContextReload, ContextSetReload] = useState(false);

  return (
    <SAMContext.Provider
      value={{
        samSearchTerm,
        setSamSearchTerm,
        samFilters,
        setSamFilters,
        intialSAMFilters,
        ContextCurrentPage,
        contextSetCurrentPage,
        ContextTotalPages,
        contextSetTotalPages,
        Contextlimit,
        ContextReload,
        ContextSetReload,
      }}
    >
      {children}
    </SAMContext.Provider>
  );
};
